import { deepMap } from '@/utils/index';
import utils from '@/utils/common';

/** 处理 getUserRoleResources 响应，生成 authority 和 btnPermissions */
export const processRoleResourcesResponse = (res: any) => {
  const resourcesData =
    res.data[0] && res.data[0].subResources && res.data[0].subResources.length
      ? res.data[0].subResources
      : [];
  utils.arrayRecursion(resourcesData, 'subResources', (item: any) => {
    if (item.frontUrl && item.frontUrl.startsWith('/microOtp')) {
      const params = new Set(item.extendAttr1 ? item.extendAttr1.split('&') : []);
      let system = '';
      if (params.has('oms') || params.has('oms=true')) {
        system = 'oms';
      } else if (params.has('tms') || params.has('tms=true')) {
        system = 'tms';
      } else if (params.has('el-data-report')) {
        system = 'el-data-report';
      }
      const systemPrefixMap: Record<string, string> = {
        oms: 'microOms',
        tms: 'microTms',
        'el-data-report': 'microDataReport',
      };
      if (system in systemPrefixMap) {
        item.frontUrl = item.frontUrl?.replace(/microOtp/g, systemPrefixMap[system]);
      }
    }
  });

  const data = res.data || [];
  const btnPermissions = utils.getResourceIds(data);
  let authority: any[] = [];
  data.forEach((item: any) => {
    if (item.subResources && item.subResources.length) {
      deepMap(item.subResources, 'subResources', (subItem: any) => {
        subItem.affix = false;
        if (subItem.extendAttr1 && subItem.extendAttr1.indexOf('affix=true') > -1) {
          subItem.affix = true;
        }
      });
      authority = authority.concat(item.subResources);
    }
  });
  return { data, authority, btnPermissions };
};
